/* eslint-disable */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { ConnectedProps, connect, useDispatch } from 'react-redux';
import { confirmWrapper } from 'src/components/Dialog';
import withRouter from '../../hooks/withRouter';
import API from '../../network';
import {
  CandidateInfoProps,
  CandidateInfoState,
  CandidateInfoViewRendererProps,
  CandidateUpdateRequest,
} from './types';
import ViewRenderer from './views';
import { AppDispatch, AppRootState } from 'src/store';
import { fetchCandidateInfo } from 'src/store/talentPoolSelectedProfile';

type CandidateInfoPropsWithRedux = CandidateInfoProps & ConnectedProps<typeof connector>;

class CandidateInfo extends Component<CandidateInfoPropsWithRedux, CandidateInfoState> {
  constructor(props: CandidateInfoPropsWithRedux) {
    super(props);

    const { reduxProps } = this.props;
    const { selectedTalentPoolProfile } = reduxProps;
    const { candidateInfo } = selectedTalentPoolProfile;

    this.state = {
      loading: false,
      loadingFailed: false,
      payTypes: [],
      workAuthorizations: [],
      resumeSources: [],
      profileInfo: candidateInfo,
      updatingForm: false,
    };
  }

  static getDerivedStateFromProps(newData: CandidateInfoPropsWithRedux, prevData: CandidateInfoState) {
    const { reduxProps } = newData;
    const { selectedTalentPoolProfile } = reduxProps;
    const { candidateInfo } = selectedTalentPoolProfile;
    if (prevData.profileInfo !== candidateInfo) {
      return {
        profileInfo: candidateInfo,
      }
    }
    return null;
  }

  componentDidMount() {
    const { reduxProps } = this.props;
    const { selectedTalentPoolProfile } = reduxProps;
    this.setState({ profileInfo: selectedTalentPoolProfile?.candidateInfo });
    this.getAllPayTypes();
    this.getAllWorkAuthorizations();
    this.getAllResumeSources();
  }

  getAllPayTypes = async () => {
    this.setState({
      loading: true,
      loadingFailed: false,
    });
    try {
      const payTypesResponse: any = await API.getInstance().getAllPaytypes();
      this.setState({
        payTypes: payTypesResponse,
      });
    } catch (e) {
      this.setState({
        loadingFailed: true,
      });
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getAllWorkAuthorizations = async () => {
    this.setState({
      loading: true,
      loadingFailed: false,
    });
    try {
      const workAuthorizationsResponse: any = await API.getInstance().getAllWorkAuthorizations();
      this.setState({
        workAuthorizations: workAuthorizationsResponse,
      });
    } catch (e) {
      this.setState({
        loadingFailed: true,
      });
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getAllResumeSources = async () => {
    this.setState({
      loading: true,
      loadingFailed: false,
    });
    try {
      const resumeSourcesRes: any = await API.getInstance().getAllResumeSources();
      this.setState({
        resumeSources: resumeSourcesRes,
      });
    } catch (e) {
      this.setState({
        loadingFailed: true,
      });
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onUpdateProfileInfo = async (requestData: CandidateUpdateRequest) => {
    this.setState({ updatingForm: true });
    const { router, dispatch } = this.props;
    const candidateId = router.params.candidateId;
    try {
      await API.getInstance().updateProfileInfo(candidateId, {
        ...requestData,
      });
      await dispatch(fetchCandidateInfo(candidateId)); // Fetch the updated candidate info
      await confirmWrapper('Information Saved Successfully', {
        variant: 'success',
        autoClose: true,
        primaryBtnLabel: 'ok',
        hideSecondaryBtn: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        updatingForm: false,
      });
    }
  };

  getProps = (): CandidateInfoViewRendererProps => {

    const {
      profileInfo,
      loading,
      payTypes,
      loadingFailed,
      updatingForm,
      resumeSources,
      workAuthorizations,
    } = this.state;

    return {
      profileInfo,
      loading,
      payTypes,
      resumeSources,
      workAuthorizations,
      loadingFailed,
      updateProfileInfo: this.onUpdateProfileInfo,
      updatingForm,
    };
  };

  render() {
    const viewProps: CandidateInfoViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

const mapStateToProps = (reduxProps: AppRootState) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  dispatch,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(withRouter(CandidateInfo));
